import { Icons } from '@commenda/kakashi';
import { useEffect, useState } from 'react';
import { DateRange } from 'react-day-picker';
import { DateRangePicker } from '../../../../components/date-range-picker';
import { formatDateRangeFromDate } from '../DateFilter/utils';
import { FilterChangeEvent } from '../types';
import { classNames } from '@commenda/utils';

interface DateRangeFilterValueProps {
  label: string;
  startDate: Date;
  endDate: Date;
  onDateChange: (startDate: Date, endDate: Date) => void;
  onFilterChange: (data: FilterChangeEvent) => void;
  onRemove: () => void;
  disabled?: boolean;
}

export const DateRangeFilterValue = ({
  label,
  startDate,
  endDate,
  onDateChange,
  onFilterChange,
  onRemove,
  disabled = false,
}: DateRangeFilterValueProps) => {
  const [dateRange, setDateRange] = useState<DateRange>({
    from: startDate,
    to: endDate,
  });

  useEffect(() => {
    onDateChange(startDate, endDate);
  }, []);

  const onDateRangeChange = (selectedDateRange: DateRange) => {
    setDateRange(selectedDateRange);
    onDateChange(selectedDateRange.from, selectedDateRange.to);
    onFilterChange({
      filterId: 'period',
      value: 'custom',
    });
  };

  return (
    <div className={classNames("inline-flex items-center gap-2 h-10 bg-bg-tertiary rounded-md whitespace-nowrap border border-border-primary", disabled && 'cursor-not-allowed')}>
      <DateRangePicker
        date={dateRange}
        disabled={disabled}
        setDate={onDateRangeChange}
        renderTrigger={(props) => (
          <div
            className={classNames("h-full flex items-center txt-small-medium text-fg-primary truncate px-2 cursor-pointer user-select-none", disabled && 'cursor-not-allowed')}
          >
            Custom: {formatDateRangeFromDate(dateRange)}
          </div>
        )}
      />
      <button
        type="button"
        onClick={onRemove}
        disabled={disabled}
        className="text-fg-quaternary hover:text-fg-quaternary-hover bg-white cursor-pointer border-l border-border-primary min-w-10 h-full flex items-center justify-center overflow-hidden rounded-r-md disabled:cursor-not-allowed"
      >
        <Icons.XClose className="size-4" />
      </button>
    </div>
  );
};
